var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-left": "20px" }, attrs: { id: "bm" } },
    [
      _c(
        "md-button",
        { staticClass: "md-fab md-mini", attrs: { to: "/bm/examples" } },
        [_c("md-icon", [_vm._v("arrow_back")])],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "md-title md-primary" }, [
        _c("h1", [_vm._v(_vm._s(_vm.bmname))])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.description))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "md-layout md-gutter md-alignment-top-center" },
        [
          _c(
            "div",
            {
              staticClass:
                "md-layout-item md-size-20 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
            },
            [
              _c(
                "div",
                { staticClass: "md-layout md-gutter md-alignment-top-center" },
                [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-card",
                        { staticClass: "tile-done height-adjust-1" },
                        [
                          _c("md-card-header", [
                            _c("div", { staticClass: "md-title" }, [
                              _vm._v("Schlüsselpartner")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "md-card-content",
                            _vm._l(_vm.kp, function(item) {
                              return _c(
                                "md-card",
                                {
                                  key: item,
                                  staticClass: "md-primary custom-chip"
                                },
                                [
                                  _c(
                                    "md-content",
                                    {
                                      staticClass: "md-primary",
                                      attrs: { align: "center" }
                                    },
                                    [_vm._v(_vm._s(item))]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "md-layout-item md-size-20 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
            },
            [
              _c(
                "div",
                { staticClass: "md-layout md-gutter md-alignment-top-center" },
                [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-card",
                        { staticClass: "tile-notstarted height-adjust-2" },
                        [
                          _c("md-card-header", [
                            _c("div", { staticClass: "md-title" }, [
                              _vm._v("Schlüsselaktivitäten")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "md-card-content",
                            _vm._l(_vm.ka, function(item) {
                              return _c(
                                "md-card",
                                {
                                  key: item,
                                  staticClass: "md-primary custom-chip"
                                },
                                [
                                  _c(
                                    "md-content",
                                    {
                                      staticClass: "md-primary",
                                      attrs: { align: "center" }
                                    },
                                    [_vm._v(_vm._s(item))]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-card",
                        { staticClass: "tile-done height-adjust-2" },
                        [
                          _c("md-card-header", [
                            _c("div", { staticClass: "md-title" }, [
                              _vm._v("Schlüsselressourcen")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "md-card-content",
                            _vm._l(_vm.kr, function(item) {
                              return _c(
                                "md-card",
                                {
                                  key: item,
                                  staticClass: "md-primary custom-chip"
                                },
                                [
                                  _c(
                                    "md-content",
                                    {
                                      staticClass: "md-primary",
                                      attrs: { align: "center" }
                                    },
                                    [_vm._v(_vm._s(item))]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "md-layout-item md-size-20 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
            },
            [
              _c(
                "div",
                { staticClass: "md-layout md-gutter md-alignment-top-center" },
                [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-card",
                        { staticClass: "tile-inprogress height-adjust-1" },
                        [
                          _c("md-card-header", [
                            _c("div", { staticClass: "md-title" }, [
                              _vm._v("Wertangebot")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "md-card-content",
                            _vm._l(_vm.vp, function(item) {
                              return _c(
                                "md-card",
                                {
                                  key: item,
                                  staticClass: "md-primary custom-chip"
                                },
                                [
                                  _c(
                                    "md-content",
                                    {
                                      staticClass: "md-primary",
                                      attrs: { align: "center" }
                                    },
                                    [_vm._v(_vm._s(item))]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "md-layout-item md-size-20 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
            },
            [
              _c(
                "div",
                { staticClass: "md-layout md-gutter md-alignment-top-center" },
                [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-card",
                        { staticClass: "tile-done height-adjust-2" },
                        [
                          _c("md-card-header", [
                            _c("div", { staticClass: "md-title" }, [
                              _vm._v("Kundenbeziehungen")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "md-card-content",
                            _vm._l(_vm.cr, function(item) {
                              return _c(
                                "md-card",
                                {
                                  key: item,
                                  staticClass: "md-primary custom-chip"
                                },
                                [
                                  _c(
                                    "md-content",
                                    {
                                      staticClass: "md-primary",
                                      attrs: { align: "center" }
                                    },
                                    [_vm._v(_vm._s(item))]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-card",
                        { staticClass: "tile-notstarted height-adjust-2" },
                        [
                          _c("md-card-header", [
                            _c("div", { staticClass: "md-title" }, [
                              _vm._v("Kanäle")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "md-card-content",
                            _vm._l(_vm.ch, function(item) {
                              return _c(
                                "md-card",
                                {
                                  key: item,
                                  staticClass: "md-primary custom-chip"
                                },
                                [
                                  _c(
                                    "md-content",
                                    {
                                      staticClass: "md-primary",
                                      attrs: { align: "center" }
                                    },
                                    [_vm._v(_vm._s(item))]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "md-layout-item md-size-20 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
            },
            [
              _c(
                "div",
                { staticClass: "md-layout md-gutter md-alignment-top-center" },
                [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-card",
                        { staticClass: "tile-inprogress height-adjust-1" },
                        [
                          _c("md-card-header", [
                            _c("div", { staticClass: "md-title" }, [
                              _vm._v("Kundensegmente")
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.cs, function(item) {
                            return _c(
                              "md-card",
                              {
                                key: item,
                                staticClass: "md-primary custom-chip"
                              },
                              [
                                _c(
                                  "md-content",
                                  {
                                    staticClass: "md-primary",
                                    attrs: { align: "center" }
                                  },
                                  [_vm._v(_vm._s(item))]
                                )
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c("md-card-content")
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "md-layout md-gutter md-alignment-top-center" },
        [
          _c(
            "div",
            {
              staticClass:
                "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
            },
            [
              _c(
                "div",
                { staticClass: "md-layout md-gutter md-alignment-top-center" },
                [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-card",
                        { staticClass: "tile-notstarted height-adjust-2" },
                        [
                          _c("md-card-header", [
                            _c("div", { staticClass: "md-title" }, [
                              _vm._v("Kostenstruktur")
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.cS, function(item) {
                            return _c(
                              "md-card",
                              {
                                key: item,
                                staticClass: "md-primary custom-chip"
                              },
                              [
                                _c(
                                  "md-content",
                                  {
                                    staticClass: "md-primary",
                                    attrs: { align: "center" }
                                  },
                                  [_vm._v(_vm._s(item))]
                                )
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c("md-card-content")
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
            },
            [
              _c(
                "div",
                { staticClass: "md-layout md-gutter md-alignment-top-center" },
                [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-card",
                        { staticClass: "tile-notstarted height-adjust-2" },
                        [
                          _c("md-card-header", [
                            _c("div", { staticClass: "md-title" }, [
                              _vm._v("Einnahmequellen")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "md-card-content",
                            _vm._l(_vm.rS, function(item) {
                              return _c(
                                "md-card",
                                {
                                  key: item,
                                  staticClass: "md-primary custom-chip"
                                },
                                [
                                  _c(
                                    "md-content",
                                    {
                                      staticClass: "md-primary",
                                      attrs: { align: "center" }
                                    },
                                    [_vm._v(_vm._s(item))]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "md-layout md-gutter md-alignment-top-center" },
      [
        _c("div", {
          staticClass:
            "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00e8f618", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00e8f618","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/businessmodel/example/canvas/ExampleCanvas.vue
// module id = null
// module chunks = 